import { CadastrarDietasDeactivateGuard } from './guards/c-dietas-deactivate.guard';
import { DietasModule } from './dietas/dietas.module';
import { NovoAcessoComponent } from './login/novo-acesso/novo-acesso.component';
import { LoginComponent } from './login/login.component';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { TopoComponent } from './topo/topo.component';
import { RodapeComponent } from './rodape/rodape.component';
import { AppRotasModule } from './app.rotas.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfigsService } from './configs.service';
import { AutenticaService } from './login/autentica.service';

import { AuthGuard } from './guards/auth.guard';
import { PacientesGuard } from './guards/pacientes.guard';
import { DietasGuard } from './guards/dietas.guard';
import { UtilsService } from './utils.service';
import { HttpModule } from '@angular/http';
import { PacienteGuard } from './guards/paciente.guard';
import { TrazPaciente } from './trazPaciente.service';
import { RecuperarSenhaComponent } from './login/recuperar-senha/recuperar-senha.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

// declarações dos módulos que são necessários para funcionar
@NgModule({
  declarations: [
    AppComponent,
    TopoComponent,
    RodapeComponent,
    LoginComponent,
    NovoAcessoComponent,
    RecuperarSenhaComponent
  ],
  imports: [
    BrowserModule,    
    FormsModule,
    ReactiveFormsModule,
    DietasModule,
    AppRotasModule,
    HttpModule
  ],
  providers: [
    ConfigsService,
    AutenticaService,
    TrazPaciente,
    AuthGuard,
    PacientesGuard,
    DietasGuard,
    PacienteGuard,
    UtilsService,
    CadastrarDietasDeactivateGuard,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts